import React, { FC, useEffect } from 'react'
import { endOfDay, startOfDay } from 'date-fns'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { ReadClientTypesRequestDto } from '@sparling/financial-common'
import { DataPicker } from '../../../../components/DatePicker'
import { getClientTypesRequest, resetClientTypesFilters } from '../../../../store/actions'
import { Search } from '../../../../components/Search'

interface IFilters {
  fromDate?: string
  toDate?: string
  search?: string
}

export const ClientTypesFilters: FC = () => {
  const dispatch = useDispatch()
  const formMethods = useForm<IFilters>({ mode: 'onChange' })
  const { watch, getValues } = formMethods

  useEffect(() => {
    dispatch(resetClientTypesFilters())
  }, [dispatch])

  useEffect(() => {
    const subscription = watch(() => {
      dispatch(getClientTypesRequest(getValues() as ReadClientTypesRequestDto))
    })

    return () => subscription.unsubscribe()
  }, [dispatch, getValues, watch])

  return (
    <FormProvider {...formMethods}>
      <DataPicker
        placeholder={'Start Date'}
        margin="8px 8px 8px 0"
        dataPickerName={'fromDate'}
        required={false}
        maxDate={getValues().toDate}
        formatValue={startOfDay}
      />
      <DataPicker
        placeholder={'End Date'}
        margin={8}
        dataPickerName={'toDate'}
        required={false}
        minDate={getValues().fromDate}
        formatValue={endOfDay}
      />
      <Search pr={8} pl={8} inputName={'search'} />
    </FormProvider>
  )
}
